// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner___spinner___1wRHb","spinner--black":"spinner___spinner--black___1kQqD","spin-cycle":"spinner___spin-cycle___14cIg"};